function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './payment-method-selection.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Controls, validators } from 'shared/helper/form';
import { BANK_TRANSFER, FREE } from 'researcher/domain/transaction/payment-method';
import { T } from 'shared/helper/translate';
import { getExternalThirdPartyPaymentMethodName, getAvailablePaymentMethods, getVisible, getShowBankInfoToChinaUsers } from '../reducer';
import PaymentMethodSelectionButton from './PaymentMethodSelectionButton';
var notEmpty = validators.notEmpty;
var Hidden = Controls.Hidden;
var PaymentMethodSelection = function PaymentMethodSelection(_ref) {
  var displayBankTransferNotice = _ref.displayBankTransferNotice,
    excludePaymentMethods = _ref.excludePaymentMethods,
    fapiaoSelectionDisabled = _ref.fapiaoSelectionDisabled,
    setPaymentMethod = _ref.setPaymentMethod,
    total = _ref.total;
  var methods = useFormContext();
  var externalThirdPartyPaymentMethodName = useSelector(getExternalThirdPartyPaymentMethodName);
  var localizationIsoCode = useSelector(function (_ref2) {
    var application = _ref2.application;
    return application.currentLocalization.isoCode.toLowerCase();
  });
  var _methods$watch = methods.watch(['paymentMethodId', 'requestAllpago', 'usingFapespFunds', 'requireFapiao', 'fapiaoRequirementConfirmed']),
    _methods$watch2 = _slicedToArray(_methods$watch, 5),
    paymentMethodId = _methods$watch2[0],
    requestAllpago = _methods$watch2[1],
    usingFapespFunds = _methods$watch2[2],
    requireFapiao = _methods$watch2[3],
    fapiaoRequirementConfirmed = _methods$watch2[4];
  var paymentMethodsUpdating = useSelector(function (_ref3) {
    var user = _ref3.user;
    return user.paymentMethods.length === 0;
  });
  var selectionDisabled = useSelector(function (_ref4) {
    var payment = _ref4.payment;
    return payment.loading;
  });
  var chinaUserAndBankTransfer = useSelector(getShowBankInfoToChinaUsers);
  var paymentMethods = useSelector(function (_ref5) {
    var order = _ref5.order,
      user = _ref5.user;
    return getAvailablePaymentMethods({
      order: order,
      user: user,
      excludePaymentMethods: excludePaymentMethods,
      requireFapiao: requireFapiao,
      requestAllpago: requestAllpago,
      usingFapespFunds: usingFapespFunds
    });
  });
  var visible = useSelector(function (_ref6) {
    var application = _ref6.application,
      user = _ref6.user;
    return getVisible({
      application: application,
      fapiaoSelectionDisabled: fapiaoSelectionDisabled,
      total: total,
      user: user,
      fapiaoRequirementConfirmed: fapiaoRequirementConfirmed
    });
  });
  var validPaymentMethod = function validPaymentMethod(value) {
    if (value === BANK_TRANSFER && displayBankTransferNotice) {
      return false;
    }
    return notEmpty(value);
  };
  useEffect(function () {
    if (total <= 0 && paymentMethodId !== FREE) {
      setPaymentMethod({
        id: FREE,
        identity: 'free'
      });
    }
    if (total > 0 && paymentMethodId === FREE) {
      setPaymentMethod({
        id: '',
        identity: ''
      });
    }
  }, [total, paymentMethodId]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "payment-method-selection localization-".concat(localizationIsoCode)
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons clearfix"
  }, paymentMethodsUpdating ? /*#__PURE__*/React.createElement("div", {
    className: "text-center card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "Loading..."
  }))) : paymentMethods.map(function (paymentMethod) {
    return /*#__PURE__*/React.createElement(PaymentMethodSelectionButton, {
      key: paymentMethod.id,
      localizationIsoCode: localizationIsoCode,
      onClick: function onClick() {
        return setPaymentMethod(paymentMethod);
      },
      paymentMethod: paymentMethod,
      paymentMethodId: paymentMethodId,
      selectionDisabled: selectionDisabled
    });
  })), chinaUserAndBankTransfer ? /*#__PURE__*/React.createElement("div", {
    className: "bank-information alert alert-primary",
    role: "alert"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(T, {
    source: "update-bank-info-heading"
  })), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, /*#__PURE__*/React.createElement(T, {
    source: "username"
  }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(T, {
    source: "username-info"
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, /*#__PURE__*/React.createElement(T, {
    source: "account"
  }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(T, {
    source: "account-info"
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, /*#__PURE__*/React.createElement(T, {
    source: "bank-heading"
  }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(T, {
    source: "bank-info"
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, /*#__PURE__*/React.createElement(T, {
    source: "location"
  }), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(T, {
    source: "location-info"
  })))))) : null, /*#__PURE__*/React.createElement(Hidden, {
    name: "paymentMethodId",
    validators: {
      validPaymentMethod: validPaymentMethod
    },
    messages: {
      validPaymentMethod: displayBankTransferNotice ? '' : 'Please choose a payment method.'
    }
  })), externalThirdPartyPaymentMethodName && /*#__PURE__*/React.createElement("div", {
    className: "third-party-payment-disclaimer"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "third-party-payment-disclaimer",
    params: {
      paymentMethodName: externalThirdPartyPaymentMethodName
    }
  }))));
};
export default PaymentMethodSelection;